import classNames from 'classnames';
import React from 'react';

import { ColorOption, getColors } from 'styleguide-v2/src/utils/colors';

import { useStyles } from './IconStyles';

type Props = {
  className?: string;
  color?: ColorOption;
  size?: 'small' | 'medium' | 'large';
};

export const EngagementIcon = ({
  className,
  color = 'info',
  size = 'medium',
}: Props) => {
  const colors = getColors(color, 'outlined');
  const styles = useStyles(colors);
  return (
    <svg
      className={classNames(
        className,
        styles.icon,
        styles[`${size}Size`],
        'svg',
      )}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g transform="translate(0,24);">
        <path
          d="M19.5 12.572l-7.5 7.428l-7.5 -7.428
           a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
        />
        <path
          d="M12 6l-3.293 3.293a1 1 0 0 0 0 1.414l.543 .543
           c.69 .69 1.81 .69 2.5 0l1 -1a3.182 3.182 0 0 1 4.5 0l2.25 2.25"
        />
        <path d="M12.5 15.5l2 2" />
        <path d="M15 13l2 2" />
      </g>
    </svg>
  );
};
